import { IRefStat } from "@interfaces/user/refs";
import { createContext, useContext } from "react";

export const RefStatContext = createContext<IRefStat>(undefined as any);
export const RefStatProvider = RefStatContext.Provider;

export function useRefStatContext(): IRefStat | undefined {
    return useContext(RefStatContext);
}